import { Box } from "@material-ui/core"
import { getPin } from "actions/Clerk/users"
import App from "contexts/App"
import { useFormik } from "formik"
import PropTypes from "prop-types"
import { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import API from "store/api"
import serialize from "store/serialize"
import * as Yup from "yup"

import LoaderButton from "../../LocalLoadingButton"
import CodeInput from "../Codeinput"
import useStyles from "./styles"

const ClerkPinForm = ({ email, nextStep, setPin }) => {
  const { openSnackBar } = useContext(App)
  const authContext = useContext(App)

  const classes = useStyles()
  const queryClient = useQueryClient()

  const pinMutation = useMutation((data) => getPin(data))

  const formik = useFormik({
    initialValues: {
      pin: "",
      email: email,
    },
    validationSchema: Yup.object().shape({
      pin: Yup.string().required("Pin code is required"),
    }),
    onSubmit: async (values) => {
      try {
        pinMutation.mutateAsync(values).then((res) => {
          setPin(values?.pin)
          const user = res.data.user
          const token = res.data.token
          serialize("user", user)
            .then(async (serializedData) => {
              await authContext.setAuthData({
                token: token,
                account: serializedData,
              })
              authContext.openSnackBar({
                message: "Login successful!",
              })
              nextStep()

              return queryClient.setQueryData("user", (oldState) => {
                return serializedData
              })
            })
            .catch((err) => {
              authContext.setAuthData({
                token: token,
                account: user,
              })
              authContext.openSnackBar({
                message: "Login successful!",
              })
              nextStep()
            })
        })
      } catch (error) {
        openSnackBar({
          message: `Invalid Pin!`,
          open: true,
          error: true,
        })
      }
    },
  })
  // Set formik field to touched onblur
  const handleTouched = (e) => {
    formik.setFieldTouched(e.target.id, true)
  }
  return (
    <Box>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          formik.submitForm()
        }}
      >
        <CodeInput
          ontouchstart={handleTouched}
          onChange={(e) => {
            formik.setFieldValue("pin", e)
          }}
        />

        <Box className={classes.loaderButtonwrapper}>
          <LoaderButton
            color="primary"
            classoverrides={{
              wrapper: classes.button,
              button: {
                root: classes.buttonRoot,
              },
            }}
            variant="contained"
            type="submit"
            working={pinMutation.isLoading}
            fullWidth
          >
            Submit Pin
          </LoaderButton>
        </Box>
      </form>
    </Box>
  )
}

ClerkPinForm.propTypes = {
  setPin: PropTypes.func,
  resetPass: PropTypes.func,
  email: PropTypes.object,
  nextStep: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  FieldsComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  ButtonsComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
}

export default ClerkPinForm
